import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Util, MediaQuery } from '@grandvisionhq/common';
import { createImageUrl } from '@grandvisionhq/utils';

const defaultImgSizes = {
    M: 768,
    L: 1024,
    XL: 1440,
    MAX: 1920
};
const Picture = ({ url , mobileUrl , alt , className , height , width , imgSizes =defaultImgSizes ,  })=>{
    const defaultParams = {
        fit: 'fillmax'
    };
    const mobileImgSizes = {
        M: imgSizes.M
    };
    const desktopImgSizes = swcHelpers.objectSpread({}, imgSizes, {
        M: undefined
    });
    const extraPixelDensities = [
        2
    ];
    const mobileSrcSet = Util.createImageSrcSet(mobileUrl !== null && mobileUrl !== void 0 ? mobileUrl : url, mobileImgSizes, defaultParams, {
        extraPixelDensities
    });
    const mobileSizes = Util.createImageSizes(mobileImgSizes, mobileUrl !== null && mobileUrl !== void 0 ? mobileUrl : url, {
        extraPixelDensities
    });
    const desktopSrcSet = Util.createImageSrcSet(url, desktopImgSizes, defaultParams, {
        extraPixelDensities
    });
    const desktopSizes = Util.createImageSizes(desktopImgSizes, url, {
        extraPixelDensities
    });
    return /*#__PURE__*/ React.createElement("picture", {
        className: classnames('picture', className)
    }, /*#__PURE__*/ React.createElement("source", {
        media: `(min-width: ${MediaQuery.Breakpoints.M}px)`,
        srcSet: desktopSrcSet,
        sizes: desktopSizes
    }), mobileUrl && /*#__PURE__*/ React.createElement("source", {
        media: `(max-width: ${MediaQuery.Breakpoints.M}px)`,
        srcSet: mobileSrcSet,
        sizes: mobileSizes
    }), /*#__PURE__*/ React.createElement("img", {
        height: height,
        width: width,
        className: "picture__image",
        src: createImageUrl(url, swcHelpers.objectSpread({}, defaultParams, {
            width,
            height
        })),
        alt: alt
    }));
};
var Picture$1 = Picture;

export { Picture$1 as default };
//# sourceMappingURL=Picture.js.map
